
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disponibilidad/[id]",
      function () {
        return require("private-next-pages/disponibilidad/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disponibilidad/[id]"])
      });
    }
  